export enum ModalId {
    ADD_NOTE = 'add-note-modal',
    ADDRESS_FORM = 'address-form-modal',
    ANNUL_CREDIT_PAYMENT = 'annul-credit-payment-modal',
    ANNUL_DELIVERY = 'annul-delivery-modal',
    ANNUL_DELIVERY_ORDER = 'annul-delivery-order-modal',
    ANNUL_INVOICE = 'annul-invoice-modal',
    ARCHIVE = 'archive-modal',
    BULK_EDIT = 'bulk-edit-modal',
    CANCEL_HOARD = 'cancel-hoard-modal',
    CASH_FUND_ITEM_FORM = 'cash-fund-item-form-modal',
    CATEGORY_SALE_YIELD_FORM = 'category-sale-yield-form-modal',
    NEGATIVE_STOCK_CATEGORY_FORM = 'negative-stock-category-form-modal',
    NEGATIVE_STOCK_PRODUCTS_FORM = 'negative-stock-products-form-modal',
    CLOSE_FINANCIAL_HOARD = 'close-financial-hoard-modal',
    CLOSE_OPERATION = 'close-operation-modal',
    COMPANY_TAX_IDS = 'company-tax-ids-modal',
    CONFIRM_PAYMENT_FORM = 'confirm-payment-form-modal',
    CONFIRM_BASE_CHANGE = 'confirm-base-change',
    CONTACT_FORM = 'contact-form-modal',
    CORRECT_HOARD_PRICE = 'correct-hoard-price-modal',
    CREATE_CUSTOMER_TYPE = 'create-customer-type-modal',
    CREATE_DELIVERY_NOTE = 'create-delivery-note-modal',
    CREATE_OPERATION_FROM_BUDGET = 'create-operation-from-budget-modal',
    CUSTOMER_WARNING = 'customer-warning-modal',
    DASHBOARD_CONFIG = 'dashboard-config-modal',
    DEFINE_LOT_FORM = 'define-lot-form-modal',
    DIRECT_ARCHIVE = 'direct-archive-modal',
    DISCOUNT_FORM = 'discount-form-modal',
    DOWNLOAD_ADJUSTMENT_NOTE_PDF = 'download-adjustment-note-pdf-modal',
    DOWNLOAD_BUDGET_PDF = 'download-budget-pdf-modal',
    DOWNLOAD_CREDIT_ACCOUNT_STATUS_PDF = 'download-credit-account-status-pdf-modal',
    DOWNLOAD_CUSTOMER_TYPE_PDF = 'download-customer-type-pdf-modal',
    DOWNLOAD_DELIVERY_NOTE = 'download-delivery-note-modal',
    DOWNLOAD_FILES = 'download-files-modal',
    DOWNLOAD_HOARD_PDF = 'download-hoard-pdf-modal',
    DOWNLOAD_HOARD_STATUS_PDF = 'download-hoard-status-pdf-modal',
    DOWNLOAD_INVOICE = 'download-invoice-modal',
    DOWNLOAD_PAYMENT_ORDER_PDF = 'download-payment-order-pdf-modal',
    DOWNLOAD_PAYMENT_RECEIPT_PDF = 'download-payment-receipt-pdf-modal',
    DOWNLOAD_PAYMENT_RECEIPTS_PDF = 'download-payment-receipts-pdf-modal',
    DOWNLOAD_PURCHASE_PDF = 'download-purchase-pdf-modal',
    DOWNLOAD_RECEIPT = 'download-receipt-modal',
    DOWNLOAD_RETENTION_CERTIFICATE_PDF = 'download-retention-certificate-pdf-modal',
    DOWNLOAD_SALE_PDF = 'download-sale-pdf-modal',
    DOWNLOAD_TICKET = 'download-ticket-modal',
    DOWNLOAD_TRUCK_PREPARATION_PDF = 'download-truck-preparation-pdf-modal',
    EDIT_CUSTOMER_TYPE = 'edit-customer-type-modal',
    EDIT_HOARD_DUE_DATE = 'edit-hoard-due-date',
    EMAIL_FORM = 'email-form-modal',
    EXCLUDED_PRODUCTS_FORM = 'excluded-products-form',
    EXTEND_HOARD_VALUE = 'extend-hoard-value-modal',
    GENERATE_CREDIT_NOTE = 'generate-credit-note-modal',
    GENERATE_NOTE = 'generate-note-modal',
    INVOICE_REQUESTED = 'invoice_requested-modal',
    LINKED_PRODUCTS_FORM = 'linked-products-form-modal',
    LOT_DATA_FORM = 'lot-data-form-modal',
    MEASURE_FORM = 'measure-form-modal',
    MESSAGE = 'message-modal',
    NON_HOARDABLE_PRODUCT_FORM = 'non-hoardable-product-form-modal',
    IIBB_PROVINCE_FORM = 'iibb-province-form-modal',
    REMOVE_IIBB_PROVINCE = 'remove-iibb-province-modal',
    OPERATION_ITEM_FORM = 'operation-item-form-modal',
    OVERWRITE_CUSTOMER_TYPE = 'overwrite-customer-type-modal',
    SPECIAL_DISCOUNT_ITEM_FORM = 'special-discount-item-form-modal',
    SPECIAL_DISCOUNT_PRICE_LIST_CHANGE = 'special-discount-price-list-change-modal',
    SPECIAL_DISCOUNT_CLEAR_CONFIRM = 'special-discount-clear-confirm-modal',
    PARTIAL_PAYMENT = 'partial-payment-modal',
    PAYMENT_ITEM_FORM = 'payment-item-form-modal',
    PHONE_FORM = 'phone-form-modal',
    PRODUCT_YIELD_FORM = 'product-yield-form-modal',
    QUICK_FORM = 'quick-form-modal',
    REMOVE = 'remove-modal',
    REMOVE_CATEGORY_SALE_YIELD = 'remove-category-sale-yield-modal',
    RENAME_CUSTOMER_TYPE = 'rename-customer-type-modal',
    RESOLVE_REQUEST = 'resolve-request-modal',
    ROADMAP_WEIGHT_WARNING = 'roadmap-weight-warning-modal',
    SALE_PAYMENT_ITEM_FORM = 'sale-payment-item-form-modal',
    SELECT_LOT = 'select-lot-modal',
    SPINNER = 'spinner-modal',
    TAX_ITEM_FORM = 'tax-item-form-modal',
    TICKET_AMOUNT_DIFFERS = 'ticket-amount-differs-modal',
    UNIGNORE_PRODUCT = 'unignore-product-modal',
    UPDATE_CUSTOMER_ADDRESS = 'update-customer-address-modal',
    UPDATE_VAT_CONDITION = 'update-vat-condition-modal',
    UPLOAD_ADDITIONAL_TICKET = 'upload-additional-ticket-modal',
    UPLOAD_CREDIT_RECEIPT = 'upload-credit-receipt-modal',
    UPLOAD_DELIVERY_NOTE = 'upload-delivery-note-modal',
    UPLOAD_EXPENSE_TICKET = 'upload-expense-ticket-modal',
    UPLOAD_INVOICE = 'upload-invoice-modal',
    UPLOAD_PAYMENT_ORDER_RECEIPT = 'upload-payment-order-receipt-modal',
    UPLOAD_SALE_RECEIPT = 'upload-sale-receipt-modal',
    VALIDATION = 'validation-modal',
    WARNING_CONFIRM = 'warning-confirm-modal'
}
